// REMOVE the notification-wrapper class and update:

import React, { useState, useEffect } from 'react';
import { EDSSystemNotification } from '@gehc-eds-react/eds-system-notification';


const NotificationComponent = ({ notificationData, onClose }) => {
    const [showNotification, setShowNotification] = useState(false);
    const [notificationType, setNotificationType] = useState('');
    const [notificationMessage, setNotificationMessage] = useState('');
    const [isInlineBanner, setIsInlineBanner] = useState(false);

    useEffect(() => {
        if (notificationData) {
            setShowNotification(notificationData.show);
            setNotificationType(notificationData.type);
            setNotificationMessage(notificationData.message);
            setIsInlineBanner(notificationData.isInline || false);
        }
        
        // Auto-hide notification after 5 seconds
        const timeoutId = setTimeout(() => {
            setShowNotification(false);
            if (onClose) onClose(); // Call parent close handler
        }, 5000);
        
        return () => {
            clearTimeout(timeoutId);
        };
    }, [notificationData, onClose]);
    
    return (
        // REMOVED the notification-wrapper div
        <EDSSystemNotification
            isOpen={showNotification}
            isInlineBanner={isInlineBanner}
            variant={notificationType}
            isMultiLineHeadline={true}
            isCancelable={true}
            headline={notificationMessage}
            alternateHeadline={""}
            description={[]}
            metadata={""}
            actionItems={{}}
            elevation={true}
            squareCorners={false}
            onClose={() => {
                setShowNotification(false);
                if (onClose) onClose();
            }}
        ></EDSSystemNotification>
    );
};

export default NotificationComponent;